import { CARD_DIGITS_ONLY_REGEX } from 'shared/utils/string/cardNumber';
import { z } from 'zod';

export const cvvValidationMessages = {
  required: 'Required',
  length: 'Must be 3 digits',
  invalid: 'Enter only digits',
};

export const cvvSchema = z
  .string({ error: cvvValidationMessages.required })
  .min(1, { error: cvvValidationMessages.required })
  .length(3, { error: cvvValidationMessages.length })
  .regex(CARD_DIGITS_ONLY_REGEX, {
    error: cvvValidationMessages.invalid,
  });
